import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import _round from 'lodash/round'
import _distanceInWords from 'date-fns/distance_in_words_strict'
import _differenceInSeconds from 'date-fns/difference_in_seconds'
import { AlertCircle } from 'react-feather'
import C2C from 'react-c2c'

import { roundAccuracy } from '../utils/geolocation'
import { color } from '../globalStyles'
import { Page, Section, Container } from '../components/common'
import Meta from '../components/Meta'
import Header from '../components/Header'
import FullscreenMessage from '../components/FullscreenMessage'

const Item = styled.h5`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  padding: 1rem;
  font-size: 1.8rem;
  cursor: ${props => (props.pointer ? 'pointer' : 'initial')};
  justify-content: ${props =>
    props.justifyStart ? 'flex-start' : 'space-between'};

  & + * {
    border-top: 1px solid ${color.lightGrey};
  }

  svg {
    margin-right: 1.5rem;
  }
`
const Output = ({ name, value, showMessage }) => {
  if (!value) return null
  return (
    <C2C text={`${value}`} onCopy={text => showMessage()}>
      <Item pointer>
        <div>{name}</div>
        <div
          style={{
            fontWeight: 400,
            textAlign: 'right',
            border: 'none'
          }}
        >
          {value}
        </div>
      </Item>
    </C2C>
  )
}

class YourLocation extends React.Component {
  state = {
    message: null
  }

  componentDidMount () {
    this.props.updateGeolocation()
  }

  showMessage = (message = 'Copied!') => this.setState({ message })

  hideMessage = () => this.setState({ message: null })

  renderPosition = ({ geolocation }) => {
    if (!geolocation) {
      return (
        <Item justifyStart>
          <AlertCircle /> Loading...
        </Item>
      )
    }
    if (geolocation.error) {
      return (
        <Item justifyStart>
          <AlertCircle /> Cannot get geolocation
        </Item>
      )
    }
    const {
      latitude,
      longitude,
      accuracy,
      altitude,
      altitudeAccuracy
    } = geolocation.position.coords
    const { timestamp } = geolocation.position

    return (
      <div>
        <Output
          showMessage={this.showMessage}
          name='Latitude'
          value={_round(latitude, 8)}
        />
        <Output
          showMessage={this.showMessage}
          name='Longitude'
          value={_round(longitude, 8)}
        />
        <Output
          showMessage={this.showMessage}
          name='Accuracy'
          value={accuracy && roundAccuracy(accuracy)}
        />
        {altitude &&
          altitudeAccuracy && (
            <Fragment>
              <Output
                showMessage={this.showMessage}
                name='Altitude'
                value={altitude && `${_round(altitude)}m`}
              />
              <Output
                showMessage={this.showMessage}
                name='Altitude Accuracy'
                value={altitudeAccuracy && roundAccuracy(altitudeAccuracy)}
              />
            </Fragment>
          )}
        <Output
          showMessage={this.showMessage}
          name='Timestamp'
          value={
            timestamp && _differenceInSeconds(new Date(), timestamp)
              ? _distanceInWords(new Date(), timestamp, {
                addSuffix: true
              })
              : 'Now'
          }
        />
      </div>
    )
  }

  render () {
    const { geolocation } = this.props
    const { message } = this.state

    return (
      <Page bgWhite>
        <Helmet title='Your Location' />
        <Meta title='Your Location' />
        <Header small title='Your Location' />
        <Section thin>
          <Container>{this.renderPosition({ geolocation })}</Container>
        </Section>
        <FullscreenMessage message={message} onComplete={this.hideMessage} />
      </Page>
    )
  }
}

YourLocation.propTypes = {
  geolocation: PropTypes.object,
  updateGeolocation: PropTypes.func.isRequired
}

export default YourLocation



// WEBPACK FOOTER //
// ./src/views/YourLocation.js